import { render, staticRenderFns } from "./elMenus.vue?vue&type=template&id=3b132872&scoped=true"
import script from "./elMenus.vue?vue&type=script&lang=js"
export * from "./elMenus.vue?vue&type=script&lang=js"
import style0 from "./elMenus.vue?vue&type=style&index=0&id=3b132872&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b132872",
  null
  
)

export default component.exports